export const environment = {
    production: true,
    test: false,
    preprod: false,
    ServerInfo: 'localhost',
    encryptionKey: '3a9Fm3xY2PcU6sN5C7WzQv7R4hL0allX',
    baseUrl: "https://api.stellar-ix.com/complianceapp/v1/api",

    redirectUrl: 'https://risk-compliance-portal.axian-group.com',
    clientIdAzure: '0abbff5b-be09-479d-81b5-60a3f26830bf',
    clientSecretAzure: 'TIP8Q~vKGzp05a7V2SfOt02qdaxfu_riUa7AVcOs',
    AuthorityAzure: 'https://login.microsoftonline.com/462b20ee-8bb0-4c05-b1fa-6fdf72dca1e3',
    ScopeAzure: 'api://fe3fd4e3-2d2c-4a5e-9478-5ae8535b77a9/EmployeeRead',
    LocalStorageKeyAzure: 'api://fe3fd4e3-2d2c-4a5e-9478-5ae8535b77a9/employeeread'
};
